// extracted by mini-css-extract-plugin
module.exports = {"emailLink":"EmailLink_emailLink__2QWci","emailLinkLabel":"EmailLink_emailLinkLabel__3OfMl"};